// Size IDs: s=300x300, m=450x300 (4.5 wide x 3 projection), l=400x450
export const SIZE_PRESETS = [
  { id: "s_300x300", label: "300 × 300 cm", price: 1_570_000, width: 300, projection: 300, popular: false, desc: "Ideális erkélyhez vagy kisebb teraszhoz." },
  { id: "m_450x300", label: "450 × 300 cm", price: 1_874_000, width: 450, projection: 300, popular: true,  desc: "A legnépszerűbb választás családoknak." },
  { id: "l_400x450", label: "400 × 450 cm", price: 2_075_000, width: 400, projection: 450, popular: false, desc: "Reprezentatív felület eseményekhez." },
];

export const CUSTOM_SIZE_ID = "custom";

export const CONTROL_OPTIONS = [
  { id: "manual",   label: "Kézi (kurbli)", desc: "Klasszikus, megbízható megoldás.", price: 0 },
  { id: "somfy_io", label: "SOMFY motor",   desc: "Prémium motoros vezérlés.",        price: 413_000 },
];

export const FRAME_COLORS = [
  { id: "ral9010", name: "RAL 9010 Krémfehér", hex: "#F4F8F4", group: "standard" },
  { id: "ral7016", name: "RAL 7016 Antracit",  hex: "#383E42", group: "standard" },
  { id: "custom",  name: "Egyedi RAL",         hex: "linear-gradient(45deg, #005f6b, #d4af37)", group: "custom" },
  { id: "wood",    name: "Fa hatású",          hex: "#8B5A2B", group: "special" },
];

export const FABRIC_COLORS = [
  { id: "white",       name: "Fehér",   hex: "#FFFFFF" },
  { id: "anthracite",  name: "Antracit", hex: "#383E42" },
  { id: "grey",        name: "Szürke",  hex: "#808080" },
  { id: "cream",       name: "Krém",    hex: "#FFFDD0" },
  { id: "black",       name: "Fekete",  hex: "#000000" },
];

export const FABRIC_TYPES = [
  { id: "opatex", name: "Opatex 850 g/m²",         desc: "Standard prémium PVC ponyva." },
  { id: "w96",    name: "Soltis W96 620 g/m²",     desc: "Prémium félig áttetsző Soltis kelme." },
];

// Size-dependent extras (HUF, additive to base)
export const SIZE_DEPENDENT_PRICES = {
  s_300x300: {
    w96_premium: 165_000,
    custom_ral:  147_000,
    wood:        288_000,
    led_spot:    380_390,
    led_box:     490_120,
  },
  m_450x300: {
    w96_premium: 247_000,
    custom_ral:  177_000,
    wood:        365_700,
    led_spot:    380_390,
    led_box:     490_120,
  },
  l_400x450: {
    w96_premium: 329_000,
    custom_ral:  215_000,
    wood:        431_000,
    led_spot:    468_170,
    led_box:     632_700,
  },
};

export const ACCESSORIES = [
  {
    id: "lighting",
    title: "Világítás",
    icon: "lightbulb",
    options: [
      { id: "led_spot", name: "LED Spot világítás", desc: "Beépített LED spotok." },
      { id: "led_box",  name: "LED Box világítás",  desc: "Dekoratív szögletes LED." },
    ],
  },
  {
    id: "sensors",
    title: "Időjárás-érzékelők",
    icon: "cloud",
    options: [
      { id: "wind_sensor", name: "Szélérzékelő", desc: "Erős szél esetén automatikus zárás.", price: 30_000 },
    ],
  },
  {
    id: "control",
    title: "Okos vezérlés",
    icon: "smartphone",
    options: [
      { id: "smartphone", name: "Okostelefon vezérlés", desc: "iOS/Android alkalmazás távvezérléshez.", price: 50_000 },
    ],
  },
];

export const ALL_ACCESSORY_LOOKUP = ACCESSORIES.flatMap((c) => c.options).reduce((m, o) => {
  m[o.id] = o;
  return m;
}, {});

export const INSTALLATION_OPTIONS = [
  { id: "with",    label: "Szakszerű telepítéssel", desc: "Saját kivitelező csapatunk végzi a kulcsrakész telepítést.", price: 274_000 },
  { id: "without", label: "Telepítés nélkül",       desc: "Saját kivitelezővel oldja meg a beépítést.",                  price: 0 },
];

export const DEFAULT_CONFIG = {
  size_id: "m_450x300",
  custom_width: 500,
  custom_projection: 400,
  control: "manual",
  frame_color: "ral9010",
  custom_ral_code: "",
  fabric_type: "opatex",
  fabric_color: "white",
  modular: "single",
  installation: "with",
  accessories: [],
  location: "",
};

// Homepage hero now uses the former texture image (the one behind the "Tervezze meg pergoláját" CTA)
export const HERO_IMG     = "https://customer-assets.emergentagent.com/job_premium-solar-shade/artifacts/rikl0qtm_s4.jpg";
export const PATIO_IMG    = "https://customer-assets.emergentagent.com/job_premium-solar-shade/artifacts/82qq3zed_s6.jpg";
export const ACCESSORY_IMG = "https://customer-assets.emergentagent.com/job_premium-solar-shade/artifacts/ey72o7id_s7.jpg";
export const TEXTURE_IMG  = "https://customer-assets.emergentagent.com/job_premium-solar-shade/artifacts/rikl0qtm_s4.jpg";
export const DETAIL_IMG   = "https://customer-assets.emergentagent.com/job_premium-solar-shade/artifacts/c9xvtunh_s5.jpg";

// Product datasheet PDF (user-provided)
export const DATASHEET_URL = "https://customer-assets.emergentagent.com/job_premium-solar-shade/artifacts/lckyxpta_Term%C3%A9kadatlap%20-%20Simple.pdf";

// Brand logo (Pergolaműhely) — local copy with transparent background, ready for black backdrop
export const BRAND_LOGO_URL = "/pergolamuhely-logo.png";

export const QUOTE_EMAIL = "info@pergolamuhely.com";
export const COMPANY_PHONE = "+36 70 881 2200";

export const VAT_RATE = 0.27; // Hungarian VAT 27%

export const HU_COUNTIES = [
  "Budapest", "Bács-Kiskun", "Baranya", "Békés", "Borsod-Abaúj-Zemplén",
  "Csongrád-Csanád", "Fejér", "Győr-Moson-Sopron", "Hajdú-Bihar", "Heves",
  "Jász-Nagykun-Szolnok", "Komárom-Esztergom", "Nógrád", "Pest", "Somogy",
  "Szabolcs-Szatmár-Bereg", "Tolna", "Vas", "Veszprém", "Zala",
];

export const formatHUF = (n) =>
  new Intl.NumberFormat("hu-HU", { style: "currency", currency: "HUF", maximumFractionDigits: 0 }).format(n);

// Get effective dimensions from a config (preset or custom)
export const getDims = (cfg) => {
  if (cfg.size_id === "custom") {
    return { width: cfg.custom_width || 400, projection: cfg.custom_projection || 350 };
  }
  const preset = SIZE_PRESETS.find((p) => p.id === cfg.size_id) || SIZE_PRESETS[0];
  return { width: preset.width, projection: preset.projection };
};

// Area in m² from config
export const getAreaM2 = (cfg) => {
  const d = getDims(cfg);
  return (d.width * d.projection) / 10_000;
};

// Get the size-dependent extra for a given option name (e.g. 'w96_premium', 'led_spot', 'led_box', 'custom_ral', 'wood')
export const getSizeExtra = (cfg, key) => {
  const sd = SIZE_DEPENDENT_PRICES[cfg.size_id];
  return sd ? (sd[key] || 0) : 0;
};
